<template>
    <div
        id="modal-container" 
        v-if="visible"
        class="modal-overlay"
        @click.self="handleOutsideClick"
    >

        <div class="modal-content">
            <table>
                <tbody>
                    <tr>
                        <td>Eser dosya adı: </td>
                        <td>{{ artworkToBeChanged.imageName }}</td>
                    </tr>
                    <tr>
                        <td>Eser bilgisi (EN): </td>
                        <td>
                            <textarea name="imageInfo_EN" id="imageInfo_EN" cols="30" rows="5" v-model="artworkToBeChanged.imageInfo_EN">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Eser bilgisi (TR): </td>
                        <td>
                            <textarea name="imageInfo_TR" id="imageInfo_TR" cols="30" rows="5" v-model="artworkToBeChanged.imageInfo_TR">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Eser sırası: </td>
                        <td>{{ artworkToBeChanged.orderNo }}</td>
                    </tr>
                </tbody>
            </table>
            <p>Eser bilgileri değiştirilecektir. Bu işlem geri alınamaz.</p>
            <div class="modal-actions">
                <button @click="updateArtworkInfo">Onayla</button>
                <button @click="$emit('cancel')">İptal</button>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';

export default{
    props:{
        visible: {
            type: Boolean,
            required: true
        },
        artwork: {
            type: Object,
            required: true
        },
        isExhibition: {
            type: Boolean,
            required: true
        }
    },

    emits: ["confirm", "cancel"],

    data(){
        return{
            artworkToBeChanged: null,
        }
    },

    methods:{
        async updateArtworkForExhibition(){
            try {
                const response = await axios.put("/api-path/Exhibition/update-image", this.artworkToBeChanged);
                console.log(response);
            } catch (error) {
                console.error("API call failed:", error);
            }
        },
        async updateArtworkForPortfolio(){
            try {
                const response = await axios.put("/api-path/Portfolio/update-image", this.artworkToBeChanged);
                console.log(response);
            } catch (error) {
                console.error("API call failed:", error);
            }
        },

        updateArtworkInfo(){
            if(this.isExhibition){
                this.updateArtworkForExhibition();
            }
            if(!this.isExhibition){
                this.updateArtworkForPortfolio();
            }
            this.$emit("confirm", this.artworkToBeChanged);
        },

        //Closing modals without clicking button
        handleKeyPress(event) {
            if (event.key === 'Escape') {
                this.artworkToBeChanged = this.artwork;
                this.$emit('cancel');
            }
        },
        handleOutsideClick() {
            this.artworkToBeChanged = this.artwork;
            this.$emit('cancel');
        }
    },

    watch:{
        artwork: {
            immediate: true,
            handler(newArtwork){
                this.artworkToBeChanged = {...newArtwork};
            }
        }
    },

    mounted() {
        document.addEventListener('keydown', this.handleKeyPress);
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    },
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 650px;
    height: 450px;
    overflow: auto;
    display: flex;
    flex-direction: column;
}

.modal-actions button {
    margin: 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.modal-actions button:first-of-type {
    background: #17A2B8;
    color: aliceblue;
}

.modal-actions button:last-of-type {
    background: #DC3545;
    color: aliceblue;
}
table{
    width: 100%; /* Tablonun genişliği modal içerisine yayılsın */
    border-collapse: collapse;
}

td{
    padding: 10px; /* Hücre içeriğine boşluk ekler */
    text-align: left; /* İçeriği sola hizalar */
    font-weight: 800;
}

</style>